const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Conteo cíclico de localizaciones',
  PAGE_DESCRIPTION:
    'En este apartado puedes realziar el conteo de los inventarios de una localización (previamente seleccionada).'
};

export default HELPER_TEXTS;
